import { union } from 'io-ts/Decoder';

import { Marker } from './Marker';
import { Path } from './Path';

export const Type = union(Marker, Path);
